function buocTrangChu({ duocThuMua }) {
  const buoc = [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Trang chủ",
      content:
        "Đây là màn hình mở đầu sau khi đăng nhập. Từ đây bạn theo dõi phiếu trong ngày và (nếu có quyền thu mua) bắt đầu một lượt thu mua mới.",
    },
  ];

  if (duocThuMua) {
    buoc.push({
      target: "#tour-trang-chu-thu-mua-btn",
      title: "Bước 2 · Bắt đầu thu mua",
      content:
        'Bấm "Thu mua" để vào luồng: chọn chủ vườn → chọn vườn → quét Sọt / cân từng loại bơ → lưu phiếu → xác nhận thanh toán. Chỉ dùng khi đang thu tại hiện trường.',
      placement: "bottom",
    });
  }

  buoc.push({
    target: "#tour-trang-chu-giao-dich-gan-day",
    title: `${duocThuMua ? "Bước 3" : "Bước 2"} · Phiếu trong ngày`,
    content:
      "Danh sách phiếu đã ghi hôm nay. Bấm một dòng để xem chi tiết. Danh sách cập nhật ngay sau khi bạn lưu phiếu mới.",
    placement: "top",
  });

  return buoc;
}

export default buocTrangChu;
